import { getToken } from "@/utils/authHelpers";
import axios from "axios";
import { API_BASE_URL } from "@/utils/api";

export const editProjectApi = async (
  id: string | null,
  name: string,
  description: string,
  deadline: string | null,
): Promise<void> => {
  if (!id) throw new Error("No id found");
  const token = await getToken();
  if (!token) throw new Error("No authentication token found");
  try {
      await axios.put(
          `${API_BASE_URL}/projects/${id}`,
          {
              name,
              description,
              deadline: deadline
                  ? new Date(deadline).toISOString().split("T")[0]
                  : null,
          },
          { headers: { Authorization: `Bearer ${token}` } },
      );
  }
  catch (err) {
      console.error(err);
      throw new Error("Failed to update project");
  }

};
